import React, { useState } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { INTERNATIONAL_DATE_FORMAT } from "../constants";

const DateInputBefor = (props) => {
    const {
        name,
        id,
        placeholder,
        errorMessage,
        validate,
        value,
        onValueChanged,
        maxDate,
    } = props;
    return (
        <DatePicker 
            dateFormat={INTERNATIONAL_DATE_FORMAT}
            name={name}
            id={id}
            placeholder={placeholder}
            maxDate={new Date()}
            selected={value} 
            onChange={(date) => onValueChanged(date)}
            className="form-control"  
        />
    );
};

export default DateInputBefor;